import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/Button';
import { PageHeader } from '../../components/shared/PageHeader';
import { InvoiceForm } from './components/InvoiceForm';
import { useInvoices } from '../../core/hooks/useInvoices';
import { useAuth } from '../../core/contexts/AuthContext';
import { DollarSign, ArrowLeft } from 'lucide-react';

export const InvoiceCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const { organizationId } = useAuth();
  const { createInvoice } = useInvoices({ organizationId });

  const handleSubmit = async (data: any) => {
    try {
      await createInvoice(data);
      navigate('/invoices');
    } catch (error) {
      console.error('Error creating invoice:', error);
      throw error;
    }
  };

  return (
    <div className="space-y-6">
      <PageHeader
        title="Create Invoice"
        description="Create a new invoice for a project"
        icon={DollarSign}
        actions={
          <Button variant="outline" onClick={() => navigate('/invoices')}>
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to Invoices
          </Button>
        }
      />

      <InvoiceForm onSubmit={handleSubmit} onCancel={() => navigate('/invoices')} />
    </div>
  );
};
